import 'globals';

(function ($, window, document) {
    $(document).ready(function() {
        if ($('#js__product-slider').length) {
            var initProductSlider = function(filteredSlidesCount) {
                    var slidesCounted = $('#js__product-slider > div').length,
                        sliderContainer = $('#js__product-slider'),
                        background = $('.product-slider__background');

                    if (slidesCounted <= 3 || slidesCounted <= sliderContainer.data('slidestoshow')  && window.matchMedia("(min-width: 1200px)").matches) {
                        sliderContainer.addClass('product-slider__limited-width');

                        // We need 3 different css classes for the background image,to provide enough conditions,
                        // to deal with the different types of slider behavior we can have.
                        background.addClass('background__type--lessThanThreeSlides');
                        background.removeClass('background__type--moreThanFiveSlides');
                        background.removeClass('background__type--fourOrFiveSlides');
                    } else {
                        sliderContainer.removeClass('product-slider__limited-width');
                        background.addClass('background__type--moreThanFiveSlides');
                        background.removeClass('background__type--lessThanThreeSlides');
                        background.removeClass('background__type--fourOrFiveSlides');

                    }
                    // if there are 4 or 5 slides we need to create an additional state,
                    // that checks if we are in a viewport lower than large
                    // and remove the limited class for that specific state.
                    // This is needed, because 4 or 5 slides should be shown as 3 'slidesToShow' in medium view,
                    // but in a large view we want those 2 state to still have the 'limited-width' class.
                    if (slidesCounted > 3 && slidesCounted <= sliderContainer.data('slidestoshow') && window.matchMedia("(max-width: 1200px)").matches){
                        sliderContainer.removeClass('product-slider__limited-width');
                        background.removeClass('background__type--moreThanFiveSlides');
                        background.removeClass('background__type--lessThanThreeSlides');
                        background.addClass('background__type--fourOrFiveSlides');
                    }

                    sliderContainer.slick({
                        centerMode: true,
                        centerPadding: 0,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        mobileFirst: true,
                        responsive: [
                            {
                                breakpoint: 992,
                                settings: {
                                    slidesToShow: slidesCounted > 3 ? 3 : 1,
                                }
                            },
                            {
                                breakpoint: 1200,
                                settings: {
                                    slidesToShow: slidesCounted > sliderContainer.data('slidestoshow') ? sliderContainer.data('slidestoshow') : 1,
                                }
                            },
                        ],
                    });

                    window.lazyLoadObject.update();
                },
                initAllSlides = function() {
                    $('#js__product-slider').html($('#js__product-slides > div').clone());
                },
                initProductSliderImages = function() {
                    window.lazyLoadObject = new LazyLoad({
                        callback_load: function (el) {
                            // window.picturefill({
                            //     reevaluate: true
                            // });
                        }
                    });
                }
            ;

            // Load all Images
            initProductSliderImages();

            // Init slider with all slides
            initAllSlides();
            initProductSlider();

            // Filter slider by option
            $('#js__product-slider-filter').on('click', '.option', function() {
                var option = $(this).data('option');
                $('#js__product-slider').slick('unslick');
                $('#js__product-slider-filter span').removeClass('btn-active');
                $(this).addClass('btn-active');

                if (option === 'all') {
                    initAllSlides();
                } else {
                    $('#js__product-slider').html($('#js__product-slides').find('.' + option).clone());
                }
                initProductSlider();
                initProductSliderImages();
            });
        }
    });
})(jQuery, window, document);
